import styled from '@emotion/styled';
import IconButton from '@mui/material/IconButton';

import { FeedbackSearchAutocomplete } from './FeedbackSearchAutocomplete';
import { useFeedbackDialogStore } from './use-feedback-dialog-store';
import { TrashCanIcon } from '../icons/TrashCanIcon';
import { SkillChip } from '../SkillChip';

import type { SkillSearchInputType } from './feedback-dialog-store';
import type { FunctionComponent } from 'react';

const SkillWrapper = styled.div({
    alignItems: 'center',
    cursor: 'pointer',
    display: 'flex',
});

export const SkillOrSkillSearchAutocomplete: FunctionComponent<{
    readonly currentFeedbackType: SkillSearchInputType;
}> = ({ currentFeedbackType }) => {
    const feedback = useFeedbackDialogStore((state) => state.feedback);
    const setFeedbackInformation = useFeedbackDialogStore((state) => state.setFeedbackInformation);

    const currentTab = feedback[currentFeedbackType];

    if (currentTab.isNothing || currentTab.value.skill.isNothing) {
        return <FeedbackSearchAutocomplete currentFeedbackType={currentFeedbackType} />;
    }

    const skill = currentTab.value.skill.value;

    const resetSkill = (): void => {
        setFeedbackInformation({
            skill: undefined,
        });
    };

    return (
        <SkillWrapper>
            <SkillChip skill={skill} variant="job-profile" />
            <IconButton
                disableRipple={true}
                sx={{
                    minWidth: 'revert',
                    px: 1,
                }}
                onClick={resetSkill}
            >
                <TrashCanIcon />
            </IconButton>
        </SkillWrapper>
    );
};
